import { Chapter } from '../../types';
import { Link } from 'wouter';

interface NotFoundProps {
  chapters: Chapter[];
  bookPermalink: string;
}

export const NotFound = ({ chapters, bookPermalink }: NotFoundProps) => {
  return (
    <div className="not-found">
      <h2>Chapter not found</h2>
      <div className="chapter-list">
        <p>
          This chapter might have been deleted or unpublished by the author.
          Here are the available chapters:
        </p>
        <ul>
          {chapters.map((chapter) => (
            <li key={chapter.id}>
              <Link
                className={
                  chapter.permalink &&
                  window.location.pathname.includes(chapter.permalink)
                    ? 'active'
                    : ''
                }
                href={`/f/${bookPermalink}/c/${chapter.permalink || ''}`}
              >
                {chapter.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
